import { Reveal } from "../motion/Reveal";
import { FUTURE_ORB_IMG } from "../../data/academyData";

export const FutureReleases = () => (
  <section data-testid="future-releases-section" className="relative py-16 md:py-24 border-y border-white/10 bg-gradient-to-r from-rose-950/20 via-black to-amber-950/10 overflow-hidden">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-[auto_1fr] gap-8 md:gap-12 items-center text-center md:text-left">
        <Reveal>
          <img
            src={FUTURE_ORB_IMG}
            alt="Abstract glowing crimson and gold orb representing AX Academy's ever-growing library"
            className="w-40 h-40 md:w-48 md:h-48 rounded-full object-cover shadow-[0_0_70px_rgba(229,9,20,0.4)] mx-auto"
          />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-heading text-2xl sm:text-3xl font-semibold text-white">All Future Releases. Forever.</h2>
          <p className="mt-4 text-zinc-400 text-lg max-w-2xl leading-relaxed">
            Every new resource, program or guide Aradhya creates — you receive it automatically, at no additional cost. You're not buying a bundle. You're becoming a permanent member of something that keeps growing.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
